import React, { useContext } from "react";
import ContentLayout from '../../layout/ContentLayout'
import TopHeader from "../../components/topheader/Index";
import Footer from "../../components/footer/Index";
import "./index.css";
import OrderProduct from "../../components/OrderProduct/OrderProduct";
import { AppContext } from '../../context/context.js';

const OrderProductPage = () => {
  const { state} = useContext(AppContext);
  const { currentUser } = state;
  return (
    <>
      <ContentLayout>
        <div className="">
          <OrderProduct type="billing" currentUser={currentUser ? currentUser : null}></OrderProduct>
        </div>
      </ContentLayout>
      <Footer />
    </>
  );
};

export default OrderProductPage;
